import React from "react";
import { devTxt, ESTADOS, getDesviacion, getEstado, hhmm } from "../SalidasStatus/statusHelper";
import { ESTADOS_SALIDA } from "./operadorHelper";

const Stat = ({ label, value, color }) => (
  <div className="operador-live-stat">
    <div className="operador-overline">{label}</div>
    <div style={{ fontSize: "20px", fontWeight: 700, marginTop: 2, color: color ?? "#fff" }}>{value}</div>
  </div>
);

/*
  Tarjeta destacada de la salida vigente. Muestra dos lecturas a la vez:
  el ciclo de vida (ESTADOS_SALIDA, del backend) y la puntualidad del último
  checkpoint (ESTADOS de statusHelper, el mismo criterio que el tablero de analistas).
*/
const SalidaEnCursoCard = ({ salida, onClick }) => {
  if (!salida) return null;

  const ciclo = ESTADOS_SALIDA[salida.estado] ?? ESTADOS_SALIDA.programada;
  const { desv, tolerancia } = getDesviacion(salida);
  const puntualidad = ESTADOS[getEstado(desv, tolerancia)];
  const total = salida.total_checkpoints || 0;
  const avance = total ? Math.round((salida.registrados / total) * 100) : 0;

  return (
    <div
      className={`operador-live${salida.estado === "en_curso" ? "" : " is-muted"}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick?.()}
    >
      <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
        <span className="operador-pill" style={{ background: ciclo.bg, color: ciclo.ink }}>
          {ciclo.label}
        </span>
        <span className="operador-pill" style={{ background: puntualidad.bg, color: puntualidad.ink }}>
          <span style={{ width: 7, height: 7, borderRadius: "50%", background: puntualidad.color }} />
          {puntualidad.label}
        </span>
        <span style={{ fontSize: "12px", color: "#a8abbb" }}>#{salida.id}</span>
        <div style={{ flex: 1 }} />
        <i className="mdi mdi-chevron-right" style={{ fontSize: "20px", color: "#a8abbb" }}></i>
      </div>

      <div style={{ fontSize: "21px", fontWeight: 700, marginTop: 12, lineHeight: 1.2 }}>
        {salida.ramal_nombre}
      </div>
      <div style={{ fontSize: "13px", fontWeight: 500, color: "#a8abbb", marginTop: 2 }}>
        Unidad {salida.unidad ?? "-"} · Tiempo {salida.timer ?? "-"} · {salida.tipo_label}
      </div>

      <div className="operador-live-stats">
        <Stat label="Salida" value={salida.hora ?? "—"} />
        <Stat label="Último check" value={hhmm(salida.ultimo_check)} />
        <Stat
          label="Diferencia"
          value={salida.diferencia == null ? "—" : devTxt(salida.diferencia)}
          color={
            salida.diferencia == null
              ? undefined
              : salida.diferencia > 0
                ? ESTADOS.que.color
                : ESTADOS.tie.color
          }
        />
      </div>

      <div className="operador-progress">
        <span style={{ width: `${avance}%` }} />
      </div>
      <div className="d-flex justify-content-between" style={{ fontSize: "11.5px", fontWeight: 600, color: "#a8abbb", marginTop: 8, gap: 10 }}>
        <span className="text-truncate">
          {salida.ultima_parada ? `Última parada: ${salida.ultima_parada}` : "Sin lecturas de checkpoint todavía"}
        </span>
        <span style={{ flex: "none" }}>
          {salida.registrados} de {total}
        </span>
      </div>
    </div>
  );
};

export default SalidaEnCursoCard;
